<template>
  <div class="white-container full-page-container common-table">
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="请输入你想搜索文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>

      <el-form-item label="活动类型：">
        <el-select ref="statusBox" v-model="search.eventType" placeholder="选择活动类型">
          <el-option label="全部" value="" />
          <el-option v-for="item in eventTypeList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动城市：">
        <el-select ref="cityBox" v-model="search.region" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="活动城市：">
        <el-cascader v-model="selectedRegion" :options="cityOptions" placeholder="全国" clearable />
      </el-form-item> -->

      <el-form-item label="活动状态：">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>

    </el-form>

    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="100" fixed />
      <el-table-column prop="type" label="活动俱乐部" width="auto" min-width="180">
        <template v-slot="scope">
          <div class="flex-box">
            <img :src="scope.row.logo" alt="" class="img-box">
            <div> {{ scope.row.clubName }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="type" label="活动类型" width="160">
        <template v-slot="scope">
          <span v-if="scope.row.eventType === 0">新手体验</span>
          <span v-else-if="scope.row.eventType === 1">进阶训练</span>
          <span v-else-if="scope.row.eventType === 2">以赛会友</span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="活动名称" width="auto" min-width="160" />
      <el-table-column prop="region" label="活动城市" width="160" />
      <el-table-column prop="beginTime" label="活动时间" width="180">
        <template #default="{row}">
          <!-- {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }} -->
          {{ row.beginTime }}
        </template>
      </el-table-column>

      <el-table-column prop="newParticipationNumber" label="活动人数" width="100" />
      <el-table-column prop="status" label="活动状态" width="160">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 0" class="el-tag--blue" size="mini">活动待开始</el-tag>
          <el-tag v-if="scope.row.status === 1" class="el-tag--green" size="mini">开放报名中</el-tag>
          <el-tag v-if="scope.row.status === 2" class="el-tag--gray" size="mini">报名截止</el-tag>
          <el-tag v-if="scope.row.status === 3" class="el-tag--end" size="mini">已结束</el-tag>
          <el-tag v-if="scope.row.status === 4" class="el-tag--purple" size="mini">活动进行中</el-tag>
          <el-tag v-if="scope.row.status === 5" class="el-tag--yellow" size="mini">待审批</el-tag>
          <el-tag v-if="scope.row.status === 6" class="el-tag--red" size="mini">已拒绝</el-tag>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="200px" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleLook(row)">查看</el-button>
          <el-button v-if="row.status!=5 && row.status!=6" size="small" type="text" class="link-color" @click="downQrCode(row)">下载签到码</el-button>
          <el-button v-if="row.status===1 || row.status===2 || row.status===3 || row.status===4" size="small" type="text" class="link-color" @click="exportIdentityCardList(row)">身份证信息表</el-button>
          <el-button v-if="row.status!=5 && row.status!=6&& row.status!=3" size="small" type="text" class="link-color" @click="handlecancel(row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

  </div>
</template>

<script>
import Dialog from '@/components/Dialog';
// import cityOptions from '@/model/cityCascader';

export default {
  components: { Dialog },
  data() {
    const statusList = [
      { id: 0, value: '活动待开始' },
      { id: 1, value: '开放报名中' },
      { id: 2, value: '报名截止' },
      { id: 3, value: '已结束' },
      { id: 4, value: '活动进行中' },
      { id: 5, value: '待审批' },
      { id: 6, value: '已拒绝' },
    ];

    const eventTypeList = [
      { id: 0, value: '新手体验' },
      { id: 1, value: '进阶训练' },
      { id: 2, value: '以赛会友' },
    ];

    return {
      search: {
        region: null,
        name: null,
        eventType: null,
        status: null,
      },
      searchSubmitted: {},
      statusList: statusList,
      eventTypeList: eventTypeList,

      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      enter: -1,
      classExcel: null,
      formDialogShow: false,
      information: {},
      currentID: null,
      cityList: [],

      // cityOptions, selectedRegion: [],
    };
  },
  computed: {},
  beforeRouteLeave(to, from, next) {
    const list = ['/rugby/activity/edit'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        region: null,
        name: null,
        eventType: null,
        status: null,
      };
      this.pageNum = 1;
    }
    next();
  },
  activated() {
    this.enter += 1;
    if (this.enter) {
      this.classExcel = null;
      this.searchSubmit();
    }
  },
  mounted() {
    this.getList();
    this.getCity();
  },

  methods: {
    // 查询
    getList() {
      this.$Api.rugby.activityList({ ...this.currentPage, ...this.searchSubmitted }).then(res => {
        this.currentPage.total = res.total;
        this.list = res.data;
      });
    },
    exportIdentityCardList(row) {
      this.$Api.rugby
        .flagActivityExampleExportTheIDCardInformationTable(row.id)
        .then(res => {
          if (!res) {
            this.$message.error("暂无数据");
          } else {
            this.$message.success("导出成功");
          }
        });
    },

    // 城市
    getCity() {
      this.$Api.rugby.cityList({}).then(res => {
        this.cityList = res;
      });
    },

    // 查询
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        this.searchSubmitted[key] = this.search[key];
      });
      // if (this.selectedRegion.length > 0) {
      //   this.searchSubmitted.region = this.selectedRegion.join(' / ');
      // }

      this.currentPage.current = 1;
      this.getList();
    },
    // 重置
    reset() {
      this.searchSubmitted = {};
      this.search = {
        region: null,
        name: null,
        eventType: null,
        status: null,
      };
      this.currentPage.current = 1;
      this.getList();
    },

    // 查看
    handleLook(row) {
      this.$router.push({ path: '/rugby/activity/edit', query: { id: row.id } });
    },

    // 下载二维码
    downQrCode(row) {
      this.$Api.rugby.qrcodeId(row.id).then((res) => {
        const link = document.createElement("a");
        link.href = res;
        link.download = `${row.name}.png`;
        link.target = "_blank";
        link.click();
      });
    },

    // 取消
    openDialog(row, { operation, icon, subTitle }) {
      this.formDialogShow = true;
      row && (this.currentID = row.id);
      this.information = { operation, icon, subTitle };
    },
    handlecancel(row) {
      this.openDialog(row, {
        operation: 'delete',
        icon: 'warn',
        subTitle: '取消后小程序用户将无法查看该活动，请确认是否取消',
      });
    },
    submitSuccess(operation) {
      const fnObj = {
        delete: this.handleDelete,
      };
      fnObj[operation]();
    },
    handleDelete() {
      this.$Api.rugby.cancelId(this.currentID).then(() => {
        this.formDialogShow = false;
        this.$message.success('取消成功');
        this.getList();
      }).catch(error => {
        this.formDialogShow = true;
        this.information = {
          operation: 'error',
          icon: 'error',
          subTitle: `${error.errorMessage}`,
        };
      });
    },

    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.el-tag.el-tag--purple {
  background-color: #f0ebfb;
  border-color: #9569e0;
  color: #722ed1;
}
.el-tag.el-tag--yellow {
  background-color: #fcf5e9;
  border-color: #ebb45a;
  color: #d38d15;
}

.el-tag.el-tag--green {
  background-color: #f1f7ef;
  border-color: #92c382;
  color: #6bac53;
}

.el-tag.el-tag--blue {
  background-color: #dde7f2;
  border-color: #65b0ff;
  color: #3791ff;
}
.el-tag.el-tag--red {
  background-color: #fae6e8;
  border-color: #dc4457;
  color: #d20017;
}
.el-tag.el-tag--end {
  background-color: #ededed;
  border-color: #b5b5b5;
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: #dbdbdb;
  border-color: #afafaf;
  color: #9b9b9b;
}
.button-img {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 14px;
}

.flex-box {
  display: flex;
  align-items: center;
  height: 104px;
  .img-box {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin-right: 16px;
  }
}
</style>
